import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import {
  findDiscount,
  getItemCategories,
  getSelectedVariants,
  getVariants,
} from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useAddToWishlistEvent = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handleAddToWishlistEvent = useCallback(
    (product) => {
      if (!isGTMEnabled) {
        return;
      }
      const {
        price,
        salePrice,
        sku,
        name,
        quantity,
        brand,
        productOptions,
        categories,
      } = product;
      sendGTMEvent({
        event: "add_to_wishlist",
        currency: CURRENCY_CODE,
        value: price,
        items: [
          {
            item_id: sku,
            item_name: name,
            affiliation: "",
            coupon: "",
            discount: findDiscount(price, salePrice),
            index: 0,
            item_brand: brand || "",
            ...getItemCategories(categories),
            item_list_id: "",
            item_list_name: "",
            item_variant:
              getSelectedVariants(productOptions) ||
              getVariants(productOptions),
            price,
            quantity: quantity || 1,
          },
        ],
      });
    },
    [isGTMEnabled]
  );

  return { handleAddToWishlistEvent };
};

export default useAddToWishlistEvent;
